import * as React from 'react';
import Footer from '../../components/footer/Footer';

import '../../assets/style.css';
import Section from '../../components/section/Section';
import Navbar from '../../components/nav/Navbar';

import {isBrowser, isMobile } from 'react-device-detect';

export default function Thematic(){

    let thematix = [
        "Mentalno zdravlja djece i mladih u doba globalnih kriza",
        "Emocionalna otpornost u kriznim situacijama: strategije za pojedince i obitelji",
        "Roditeljstvo u kriznim vremenima – izazovi, prilagodbe i uloga psihološke podrške",
"Uloga digitalnih tehnologija i mentalno zdravlje",
"Uloga zajednice u prevenciji ovisnosti",
"Profesionalno umrežavanje kao odgovor na krizne situacije",
"Organizacijska psihologija u vrijeme digitalne transformacije društva",
"Mentalno zdravlje i otpornost sportaša",
"Krizna razdoblja adolescencije i mlađe odrasle dobi: veza slike tijela i poremećaja hranjenja",
"Mentalno zdravlje zaposlenika u digitalnom dobu: prilagodba, inovacije i otpornost",
"Otpornost i dobrobit starijih osoba u izazovnim situacijama",
"Seksualnost, seksualne orijentacije i rodni identitet kroz životni vijek",
"Psihologija i ljudska prava",
"Mentalno zdravlje i otpornost pojedinaca i grupa u kontekstu ratnih zbivanja",
"Učenje budućnosti: izazovi umjetne inteligencije",
"Izvrsnost i odličan uspjeh tijekom školovanja – garancija znanja ili ne?",
"Mediji i mentalno zdravlje mladih",
"Otpornost učenika u uvjetima obrazovnih promjena: Uloga školskog psihologa u prevenciji i intervenciji",
"Suradnja psihologa s roditeljima u dječjem vrtiću: izazovi i mogućnosti",
"Uloga psihologa u prepoznavanju i podršci djece s različitim putevima razvoja"

    ]

    return (
        <>
        <Navbar/>
        
        <div className="background-opaque flex-column" style={{height:"100%", position:"relative"}}>
            <div className="flex-column centered" style={{paddingTop:"32vh", minHeight:"100vh", alignItems:"center"}}>
                <h1 className='pillbox-huge button-huge hpd-green-background pillbox-like' style={{fontWeight:"400", fontSize:isMobile?"2rem":"3rem", marginBottom:"2rem", width:"80%", textAlign:"center"}}>Tematska područja</h1>
                <div className="pillbox-like pillbox-huge light-background-element" style={{width:isMobile?"95%":"80%", position:"relative"}}>
                    
                        <ul>
                            {
                                thematix.map((theme, index)=>{
                                    return <li style={{textTransform:"none"}}>{theme}</li>
                                })
                            }
                        </ul>
                
            
                </div>
            <h2 style={{padding:"2rem"}}>
                    Osim ponuđenih tema, na konferenciji je moguće prijaviti i sve ostale teme iz područja
                    psihologije, a sudjelovanje je moguće kroz različite oblike izlaganja
                    </h2>
            </div>
        
        </div>
        <Footer/>
        </>

    )
}